// Global Instructions Rule Applied!

import { ContactState } from '../../interfaces/contacts.ts'
import { ContactRecordFields } from '../../data_models/contact_record.ts'

/**
 * Selector function to find a contact by ID in contacts.data array
 * Returns the first match found, or undefined if not found
 *
 * Usage:
 * const contact = useSelector((state) => selectContactById(state, contactId))
 */
export const selectContactById = (state: { contacts: ContactState }, contactId: string | number | null | undefined) => {
  if (!contactId || !state.contacts) return undefined

  const contactIdString = contactId.toString()

  const contact = state.contacts.data.find(
    (contact) => contact[ContactRecordFields.contacts__id]?.toString() === contactIdString
  )

  return contact
}
